/**
 * @generated SignedSource<<8111652010c92d1242634b59131413ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DuplicateComponentInput = {
  clientMutationId?: string | null | undefined;
  id: string;
  newId?: string | null | undefined;
  newWeekId?: string | null | undefined;
};
export type CopyComponentDialogMutation$variables = {
  input: DuplicateComponentInput;
};
export type CopyComponentDialogMutation$data = {
  readonly duplicateComponent: {
    readonly component: {
      readonly id: string;
    };
  } | null | undefined;
};
export type CopyComponentDialogMutation = {
  response: CopyComponentDialogMutation$data;
  variables: CopyComponentDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DuplicateComponentPayload",
    "kind": "LinkedField",
    "name": "duplicateComponent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Component",
        "kind": "LinkedField",
        "name": "component",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CopyComponentDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CopyComponentDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "75d0f8a6be67863f90529c2de237810d",
    "id": null,
    "metadata": {},
    "name": "CopyComponentDialogMutation",
    "operationKind": "mutation",
    "text": "mutation CopyComponentDialogMutation(\n  $input: DuplicateComponentInput!\n) {\n  duplicateComponent(input: $input) {\n    component {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed6b27459ac34f1d28d38a1a11198a10";

export default node;
